import { Switch } from '@headlessui/react';
import cn from './cn.js';

/** On/off switch built on Headless UI. */
export default function Toggle({ checked, onChange, label, description, disabled = false, size = 'md', className, srLabel }) {
  const track = size === 'sm' ? 'h-5 w-9' : 'h-6 w-11';
  const thumb = size === 'sm' ? 'h-4 w-4' : 'h-5 w-5';
  const translate = size === 'sm' ? 'translate-x-4' : 'translate-x-5';

  const control = (
    <Switch
      checked={!!checked}
      onChange={onChange}
      disabled={disabled}
      className={cn(
        'relative inline-flex shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
        track,
        checked ? 'bg-indigo-600' : 'bg-gray-200',
      )}
    >
      {srLabel && <span className="sr-only">{srLabel}</span>}
      <span
        aria-hidden="true"
        className={cn(
          'pointer-events-none inline-block transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
          thumb,
          checked ? translate : 'translate-x-0',
        )}
      />
    </Switch>
  );

  if (!label) return control;

  return (
    <Switch.Group as="div" className={cn('flex items-center justify-between gap-4', className)}>
      <span className="flex flex-col">
        <Switch.Label as="span" className="text-sm font-medium text-gray-900" passive>
          {label}
        </Switch.Label>
        {description && (
          <Switch.Description as="span" className="text-sm text-gray-500">
            {description}
          </Switch.Description>
        )}
      </span>
      {control}
    </Switch.Group>
  );
}
